import Service from './Service';

/**
 * 授信商户端接口
 */
class CreditMerchantService extends Service {
    /**
     * 授信额度--统计信息(商户)
     */
    queryCreditStatistics() {
        return this.axios.get('api/pay/v1/credit/merchant/statistics');
    }

    /**
     * 授信额度--状态列表(商户)
     */
    queryCreditStatusList() {
        return this.axios.get('api/pay/v1/credit/merchant/status-list');
    }

    /**
     * 授信额度--授信列表(商户)
     * @return
     */
    queryCreditInfoList(params) {
        return this.axios.get('api/pay/v1/credit/merchant/list', { params });
    }

    /**
     * 授信额度--授信详情(商户)
     * @return
     */
    queryCreditDetailInfo(params) {
        return this.axios.get('api/pay/v1/credit/merchant/detail', { params });
    }

    /**
     * 授信详情--冻结授信(商户)
     * @return
     */
    frozenCredit(params) {
        return this.axios.put('api/pay/v1/credit/merchant/frozen', params);
    }

    /**
     * 授信详情--取消冻结(商户)
     * @return
     */
    unfrozenCredit(params) {
        return this.axios.put('api/pay/v1/credit/merchant/unfrozen', params);
    }

    /**
     * 授信详情--停用授信(商户)
     * @return
     */
    disableCredit(params) {
        return this.axios.put('api/pay/v1/credit/merchant/disabled', params);
    }

    /**
     * 授信详情--重新启用(商户)
     * @return
     */
    enableCredit(params) {
        return this.axios.put('api/pay/v1/credit/merchant/enable', params);
    }

    /**
     * 授信详情--调整授信额度(商户)
     * @return
     */
    modifyCreditOverdraft(params) {
        return this.axios.put('api/pay/v1/credit/merchant/overdraft', params);
    }

    /**
     * 授信详情--月度账单统计信息(商户)
     * @return
     */
    queryCreditMerchantMonthBillStatistics(params) {
        return this.axios.get('api/pay/v1/credit/merchant/month-bill-statistics', { params });
    }

    /**
     * 授信详情--月度账单交易列表(商户)
     * @return
     */
    queryCreditMerchantMonthBillTradeList(params) {
        return this.axios.get('api/pay/v1/credit/merchant/month-bill-trade-list', { params });
    }

    /**
     * 授信详情--变更记录(商户)
     * @return
     */
    queryCreditChangeLogList(params) {
        return this.axios.get('api/pay/v1/credit/merchant/change-log-list', { params });
    }

    /**
     * 开通授信--选择钱包列表(商户)
     * @return
     */
    queryWalletList(params) {
        return this.axios.get('api/pay/v1/credit/merchant/credit/corporation-wallet-list', { params });
    }

    /**
     * 开通授信--开通授信(商户)
     * @return
     */
    openCredit(params) {
        return this.axios.post('api/pay/v1/credit/merchant/credit/add', params);
    }

    /**
     * 授信交易--统计信息(商户)
     * @return
     */
    queryCreditTradeStatistics(params) {
        return this.axios.get('api/pay/v1/credit/merchant/trade-statistics', { params });
    }

    /**
     * 授信交易--交易类型列表(商户)
     * @return
     */
    queryCreditBusiTypeList(params) {
        return this.axios.get('api/pay/v1/credit/merchant/busi-type-list', { params });
    }

    /**
     * 授信交易--交易列表(商户)
     * @return
     */
    queryCreditTradeList(params) {
        return this.axios.get('api/pay/v1/credit/merchant/trade-list', { params });
    }
}

const creditMerchantService = new CreditMerchantService();
export default creditMerchantService;
